import React from 'react';
import { ReviewItem } from '@/types/api';

import { useState } from 'react';
import { useToast } from '@/hooks/V3/useToast';
import { useQueries } from '@tanstack/react-query';
import { UseQueryResult } from '@tanstack/react-query';
import AutoResizeTextarea from './AutoResizeTextarea';
import { usePost } from '@/api';
import { CPLAT_API_ROUTES } from '@/api';
import { useAppSelector } from '@/redux/store';

import { cn } from '@/utils/tailwind';
import AlreadyAnswered from './AlreadyAnswered';
import AnswerController from './AnswerController';

const RightContentSection = ({
  review,
  allMarketsQueries,
}: {
  review: ReviewItem;
  allMarketsQueries: any;
}) => {
  const isAnswered = review.ReviewCommentList && review.ReviewCommentList.length > 0;
  const [comment, setComment] = useState('');
  const user = useAppSelector((state) => state.user);

  const [isComposing, setIsComposing] = useState(false);

  const { mutate, isPending } = usePost(CPLAT_API_ROUTES.setReviewComment);
  const { showToast } = useToast();

  const MAX_LENGTH = 300;

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const value = e.target.value;
    // 조합 중이 아니면 바로 자르기
    if (!isComposing && value.length > MAX_LENGTH) {
      setComment(value.slice(0, MAX_LENGTH));
    } else {
      setComment(value);
    }
  };
  // useQueries 반환값
  const allMarketsResults = useQueries({ queries: allMarketsQueries }) as UseQueryResult<any>[];

  // refetch 모든 마켓
  const refetchAllMarkets = () => {
    allMarketsResults.forEach((result) => result.refetch && result.refetch());
  };

  const handleRegister = () => {
    if (!comment.trim()) return;
    mutate(
      {
        cplatToken: user.CplatToken,
        Content: comment,
        ReviewNo: review.ReviewNo,
        StoreId: review.StoreId,
        MarketNameEnglish: review.MarketNameEnglish,
        EsmplusReviewType: review.EsmplusReviewType,
        EsmplusInternalId: review.EsmplusInternalId,
        EsmplusProductNo: review.EsmplusProductNo,
      },
      {
        onSuccess: (response) => {
          // response.data.code == 200 체크
          if (response.data.code == 200) {
            showToast(
              'success',
              review.MarketNameEnglish === 'smartstore'
                ? '답변이 등록되었어요. 실제 등록까지 최대 10분 정도 소요될 수 있어요.'
                : '답변이 등록되었어요',
            );
            setComment('');
            refetchAllMarkets(); // 여기서 호출!
          } else {
            showToast('warning', '답변 등록에 실패했습니다. 다시 시도해주세요.');
          }
        },
        onError: () => {
          showToast('warning', '답변 등록 중 오류가 발생했습니다.');
        },
      },
    );
  };

  return (
    <div
      className={cn(
        'bg flex h-full flex-col gap-2 rounded-[8px] border px-[10px] py-[12px]',
        'transition-all duration-200 ease-in-out focus-within:border-point-400 ',
        isAnswered === true && 'bg-gr-50',
      )}
    >
      {isAnswered ? (
        <AlreadyAnswered review={review} />
      ) : (
        <div className="flex h-full flex-col gap-2">
          <div className="w-full flex-1">
            {/* 답변 입력란 */}
            <AutoResizeTextarea
              value={comment}
              onChange={handleChange}
              onCompositionStart={() => setIsComposing(true)}
              onCompositionEnd={(e) => {
                setIsComposing(false);
                if (e.currentTarget.value.length > MAX_LENGTH) {
                  setComment(e.currentTarget.value.slice(0, MAX_LENGTH));
                }
              }}
              placeholder="답변을 입력하세요"
            />
          </div>

          <AnswerController
            comment={comment}
            setComment={setComment}
            handleRegister={handleRegister}
            isLoading={isPending}
            review={review}
          />
        </div>
      )}
    </div>
  );
};

export default RightContentSection;
